<template>
    <v-container fluid class="mb-12 mb-lg-0">
        <v-row justify="center">
            <v-col md="12">
                <v-card width="100%">
                    <v-card-title class="d-block text-center font-weight-bold primary py-2 admin-title" style="word-break: normal">REPORTE CLIENTE</v-card-title>
                    <v-btn bottom color="warning primary--text" depressed fab absolute right small @click="getReport(1)">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col md="12">
                <v-card>
                    <v-card-text class="pb-0">
                        <v-row justify="center">
                            <v-col cols="12" sm="6" md="3">
                                <v-select
                                    :label="labels.country"
                                    :items="countries"
                                    name="country"
                                    v-model="form.country"
                                    :disabled="loading"
                                    prepend-icon="mdi-map-marker"
                                    item-text="name"
                                    item-value="code">
                                    <template v-slot:selection="{ item }">
                                        <v-flex>
                                            <v-avatar size="28px">
                                                <img :src="'/img/country/' + item.code + '.png'" :alt="(item.name).toLowerCase()" />
                                            </v-avatar>
                                            <span class="ml-1">{{ item.name }}</span>
                                        </v-flex>
                                    </template>
                                    <template v-slot:item="{ item }">
                                        <v-list-item-avatar>
                                            <img :src="'/img/country/' + item.code + '.png'" :alt="(item.name).toLowerCase()" />
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="item.name"/>
                                        </v-list-item-content>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-select
                                    :label="labels.year"
                                    :items="years"
                                    name="year"
                                    v-model="form.year"
                                    :disabled="loading"
                                    prepend-icon="mdi-calendar-range"
                                    item-text="text"
                                    item-value="value"/>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-row dense class="report-actions">
                                    <v-col cols="6">
                                        <v-btn color="primary" block x-large depressed @click="getReport">
                                            <v-icon>mdi-filter</v-icon>&nbsp;Filtrar
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-btn color="success" block x-large depressed @click="getDownload">
                                            <v-icon>mdi-file-excel</v-icon>&nbsp;Descargar
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-title>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details/>
                    </v-card-title>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :search="search"
                        :loading="loading"
                        :no-data-text="noDataText"
                        :footer-props="footerProps"
                        :sort-by="['total_amount']"
                        :sort-desc="[true]"
                        must-sort>
                        <template v-slot:item.sender="{ item }">
                            <span style="text-transform: capitalize">{{ (item.sender || '').toLowerCase() }}</span>
                        </template>
                        <template v-slot:item.total_amount="{ item }">
                            <strong>{{ item.total_amount_text }}</strong>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-btn color="primary" small depressed dark @click="openDetails(item)">
                                <v-icon>mdi-eye</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog" scrollable max-width="1200px" width="90%">
            <v-card v-if="selected">
                <v-card-title class="headline primary d-block admin-title" style="word-break: normal">
                    Detalle de envíos - {{ selected.sender }} / {{ selected.document_text }}
                </v-card-title>
                <v-card-text class="pa-4">
                    <v-row dense class="mb-2">
                        <v-col cols="12" md="4"><strong>País:</strong> {{ selected.country }}</v-col>
                        <v-col cols="12" md="4"><strong>Cuenta:</strong> {{ selected.bank }} - {{ selected.account }}</v-col>
                        <v-col cols="12" md="4"><strong>Total:</strong> {{ selected.total_amount_text }}</v-col>
                    </v-row>
                    <v-data-table :headers="detailHeaders" :items="selected.details" :footer-props="footerProps" dense>
                        <template v-slot:item.id="{ item }">
                            <strong>{{ item.id }}</strong>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="error" depressed @click="dialog = false"><v-icon>mdi-close-circle</v-icon>&nbsp;Cerrar</v-btn>
                    <v-spacer/>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import axios from 'axios';
    import Form from '../../../helpers/form';

    export default {
        name: 'IdentityReport',
        mixins: [ Form ],
        props: [ 'user' ],
        data: () => ({
            search: '',
            headers: [
                { text: 'País', value: 'country', sortable: false },
                { text: 'Plataforma', value: 'source', sortable: false },
                { text: 'ID Cliente', value: 'user_id', align: 'end', sortable: false },
                { text: 'Documento', value: 'document_text', sortable: false },
                { text: 'Cliente', value: 'sender', sortable: false },
                { text: 'Banco / Oficina', value: 'bank', sortable: false },
                { text: 'Cuenta', value: 'account', sortable: false },
                { text: 'Moneda', value: 'currency', align: 'center', sortable: false },
                { text: 'Cantidad', value: 'transfers_count', align: 'end', sortable: false },
                { text: 'Total enviado', value: 'total_amount', align: 'end' },
                { text: 'Acción', value: 'action', align: 'center', filterable: false, sortable: false }
            ],
            detailHeaders: [
                { text: 'ID', value: 'id', align: 'end', sortable: false },
                { text: 'ID Pago', value: 'payment_id', align: 'end', sortable: false },
                { text: 'Beneficiario', value: 'receiver', sortable: false },
                { text: 'Países', value: 'countries', sortable: false },
                { text: 'Depósito', value: 'deposit_amount_text', align: 'end', sortable: false },
                { text: 'Enviado', value: 'amount_send_text', align: 'end', sortable: false },
                { text: 'Pagado', value: 'amount_receiver_text', align: 'end', sortable: false },
                { text: 'Fecha Final', value: 'updated_at', sortable: false }
            ],
            items: [],
            loading: true,
            noDataText: 'No hay envíos completados con documento de identidad',
            footerProps: {
                itemsPerPageOptions: [50, 100, 250, 500, -1]
            },
            dialog: false,
            selected: null,
            labels: {
                country: 'País Origen',
                year: 'Año'
            },
            form: {
                country: '000',
                year: undefined
            },
            years: [],
            countries: [
                { name: 'Todos', code: '000' },
                { name: 'Brasil', code: 'BRA' },
                { name: 'Chile', code: 'CHL' },
                { name: 'Colombia', code: 'COL' },
                { name: 'Ecuador', code: 'ECU' },
                { name: 'Europa', code: 'EUR' },
                { name: 'Mexico', code: 'MEX' },
                { name: 'Panama', code: 'PAN' },
                { name: 'Peru', code: 'PER' },
                { name: 'Estados Unidos', code: 'USA' },
                { name: 'Venezuela', code: 'VEN' }
            ]
        }),
        mounted () {
            this.form.country = this.$route.query.country || '000';
            this.setYears();
            this.getReport();
        },
        methods: {
            getReport(v) {
                clearTimeout(this.timeout);
                this.loading = true;
                if (v === 1) { this.items = []; }
                axios.post('/api/reports/identity', this.form).then((res) => {
                    this.items = res.data.items.map((item) => ({
                        ...item,
                        details: item.details.map((detail) => ({
                            ...detail,
                            countries: detail.country_send + ' ➤ ' + detail.country_receiver
                        }))
                    }));
                }).catch(err => {
                    if (err.response && err.response.data && err.response.data.errors) {
                        this.handleErrors(err.response.data.errors);
                    }
                }).then(() => {
                    this.loading = false;
                });
                this.timeout = setTimeout(this.getReport, 300000);
            },
            setYears() {
                const currentYear = new Date().getFullYear();
                this.form.year = currentYear;
                this.years = [];
                for (let year = currentYear; year >= currentYear - 5; year--) {
                    this.years.push({ text: year.toString(), value: year });
                }
            },
            openDetails(item) {
                this.selected = item;
                this.dialog = true;
            },
            getDownload() {
                const url = '/api/export/reports/identity/' + this.form.year + '/' + this.form.country;
                axios.get(url, { responseType: 'blob' }).then((res) => {
                    const blob = new Blob([res.data], { type: res.data.type });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    const disposition = res.headers['content-disposition'] || '';
                    const filename = disposition.indexOf('filename=') >= 0 ? disposition.split('filename=')[1].replace(/"/gi, '') : 'documentos.xlsx';
                    link.setAttribute('download', 'Reporte Cliente ' + filename);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                });
            }
        }
    }
</script>

<style scoped>
.admin-title {
    background-color: #0b3558 !important;
    color: #f6c343 !important;
}

.report-actions .v-btn {
    min-height: 46px;
}

</style>
